function registerModule(obj) {
  let scope = typeof this.options !== 'undefined' && this.options.length && Array.isArray(this.options[0]) ? this.options[0] : false;
  if (!scope) {
    scope = !Object.prototype.hasOwnProperty.call(this.context, 'modules') ? [] : false;
  }
  if (!scope) {
    scope = this.context.modules;
  }
  if (Object.prototype.hasOwnProperty.call(obj, 'init')) {
    obj.init();
  }

  this.scope.push(obj);
  this.context.ready.modules.push(Object.keys(obj)
    .toString());
}

export function register(...args) {
  if (!args.length) throw new Error('Missing arguments.');
  const self = this;
  if (Array.isArray(args[0])) {
    const [modules, ...options] = args;
    modules.forEach(registerModule, {
      context: self,
      options,
    });
  }
  const { name, module: moduleEntry, to } = args;

  const checkNameFormat = Array.isArray(name) ? name : Object.defineProperties({}, JSON.parse(`[{${name}:${JSON.stringify(moduleEntry)}]`));
  const useLocalScope = typeof (to) !== 'undefined' && Array.isArray(to) ? to : false;
  const scope = !useLocalScope && Object.prototype.hasOwnProperty.call(this, 'modules') ? this.modules : [];
}

/**
 * Search registered modules or an array of passed modules
 * @param {string} nameKey - name of module to search for
 * @param {array} modules - null | array of modules to search
 * @returns {*}
 */
export function search(nameKey, modules) {
  const useLocalModules = typeof (modules) !== 'undefined';
  const useGlobalModules = typeof (modules) === 'undefined' && Object.prototype.hasOwnProperty.call(this, 'modules');

  // Nothing to search
  if (!useLocalModules && !useGlobalModules) return {};
  const searchIn = useLocalModules ? modules : this.modules;
  const { length: resultsFound, ...resultsList } = searchIn.filter(module => Object.keys(module)
    .indexOf(nameKey) > -1, nameKey);
  return !resultsFound ? {} : Object.values(Object.values(resultsList)
    .shift())
    .shift();
}

export default {
  register,
  search,
};
